import Icons, { SvgIconProps } from '../Icons';

export default function (props: SvgIconProps) {
  return (
    <Icons {...props}>
      <path
        d="M6.625 20.5C6.15833 20.5 5.771 20.346 5.463 20.038C5.15433 19.7293 5 19.3417 5 18.875V7.5H6V18.875C6 19.025 6.06667 19.1667 6.2 19.3C6.33333 19.4333 6.475 19.5 6.625 19.5H15V20.5H6.625ZM9.625 17.5C9.15833 17.5 8.771 17.346 8.463 17.038C8.15433 16.7293 8 16.3417 8 15.875V5.1C8 4.65 8.15433 4.27067 8.463 3.962C8.771 3.654 9.15833 3.5 9.625 3.5H17.4C17.85 3.5 18.2293 3.654 18.538 3.962C18.846 4.27067 19 4.65 19 5.1V15.875C19 16.3417 18.846 16.7293 18.538 17.038C18.2293 17.346 17.85 17.5 17.4 17.5H9.625ZM9.625 16.5H17.4C17.55 16.5 17.6877 16.4333 17.813 16.3C17.9377 16.1667 18 16.025 18 15.875V5.1C18 4.95 17.9377 4.81233 17.813 4.687C17.6877 4.56233 17.55 4.5 17.4 4.5H9.625C9.475 4.5 9.33333 4.56233 9.2 4.687C9.06667 4.81233 9 4.95 9 5.1V15.875C9 16.025 9.06667 16.1667 9.2 16.3C9.33333 16.4333 9.475 16.5 9.625 16.5Z"
        fill={props.color || '#0092CC'}
      />
    </Icons>
  );
}
